import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MenuForm from "./MenuForm";
import { updateMenu, getMenuById } from "../../api/MenuService";
import { getErrorMessage } from "../../utils/errorHandler";
import FullPageLoader from "../../common/FullPageLoader";

export default function MenuEdit() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const id = location.state?.menuId || params.id;

  const [menuData, setMenuData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [pageError, setPageError] = useState("");

  const initialFormData = useMemo(
    () => ({
      name: menuData?.name || "",
      slug: menuData?.slug || "",
      type: menuData?.type || "",
      parentId: menuData?.parentId?._id || menuData?.parentId?.id || menuData?.parentId || "",
      visible: menuData?.visible !== false,
      order: menuData?.order ?? "",
    }),
    [menuData],
  );

  useEffect(() => {
    if (!id) {
      navigate("/menu");
      return;
    }
    const fetchMenu = async () => {
      try {
        setPageError("");
        const res = await getMenuById(id);
        setMenuData(res?.data?.data || res?.data || res);
      } catch (error) {
        setMenuData(null);
        setPageError(getErrorMessage(error));
      } finally {
        setPageLoading(false);
      }
    };

    fetchMenu();
  }, [id, navigate]);

  const handleUpdate = async (formData) => {
    setLoading(true);

    try {
      const res = await updateMenu(id, formData);

      if (res?.success === false) return res;
      return { success: true, data: res };
    } catch (error) {
      return {
        success: false,
        message: getErrorMessage(error),
        error: error?.response?.data?.error || {},
      };
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return <FullPageLoader text="Loading menu details..." />;
  }

  if (pageError || !menuData) {
    return <div className="alert alert-danger m-4">{pageError || "Menu not found"}</div>;
  }

  return (
    <MenuForm
      isEdit={true}
      loading={loading}
      onSubmit={handleUpdate}
      initialData={initialFormData}
      currentMenuId={id}
    />
  );
}
